const publicFile = (path: string) => `${import.meta.env.BASE_URL}${path}`
export const supportResources = {
  welcomeGuide: import.meta.env.VITE_MA_WELCOME_GUIDE_URL || '',
  paymentsGuide: import.meta.env.VITE_MA_PAYMENTS_GUIDE_URL || '',
  adjudicationGuide:
    import.meta.env.VITE_MA_ADJUDICATION_GUIDE_URL ||
    publicFile('api/Cliente/Cliente/Home/ObtenerArchivoPublico?ruta=guia-adjudicatario.pdf'),
  clabe: import.meta.env.VITE_MA_CLABE_URL || '',
  app: import.meta.env.VITE_MA_APP_URL || '',
  appointments: 'https://appointments.clients.debmedia.com/#/company/hircasa/schedules',
  directDebit: publicFile('cliente/cliente/pdf/formato/DomiciliacionMensualidades.pdf'),
  lifeClaim: publicFile('cliente/cliente/pdf/formato/ReclamacionVida.pdf'),
  disabilityClaim: publicFile('cliente/cliente/pdf/formato/siniestro/invalidez-total.pdf'),
  unemploymentClaim: publicFile('cliente/cliente/pdf/formato/siniestro/desempleo.pdf'),
  insuranceEmail: 'mailto:atencionseguros@hircasa.com.mx',
  supportEmail: 'mailto:atencionaclientes@hircasa.com.mx',
  mortgageEmail: 'mailto:cancelacionhipoteca@hircasa.com.mx'
} as const
